module.exports = __webpack_public_path__ + "img/sec_doc.29da819d.jpg";